/* tslint:disable */
/* eslint-disable */
/**
 * Swipe4Work Employer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SubscriptionStatusFromJSON, SubscriptionStatusToJSON, } from './SubscriptionStatus.js';
/**
 * Check if a given object implements the ListCompanySubscriptionsCompanySubscriptionDto interface.
 */
export function instanceOfListCompanySubscriptionsCompanySubscriptionDto(value) {
    if (!('name' in value) || value['name'] === undefined)
        return false;
    if (!('status' in value) || value['status'] === undefined)
        return false;
    if (!('startDate' in value) || value['startDate'] === undefined)
        return false;
    if (!('jobSlots' in value) || value['jobSlots'] === undefined)
        return false;
    if (!('durationInMonths' in value) || value['durationInMonths'] === undefined)
        return false;
    if (!('pricePerMonthExclVat' in value) || value['pricePerMonthExclVat'] === undefined)
        return false;
    return true;
}
export function ListCompanySubscriptionsCompanySubscriptionDtoFromJSON(json) {
    return ListCompanySubscriptionsCompanySubscriptionDtoFromJSONTyped(json, false);
}
export function ListCompanySubscriptionsCompanySubscriptionDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'subscriptionId': json['subscriptionId'] == null ? undefined : json['subscriptionId'],
        'name': json['name'],
        'status': SubscriptionStatusFromJSON(json['status']),
        'startDate': (new Date(json['startDate'])),
        'endDate': json['endDate'] == null ? undefined : (new Date(json['endDate'])),
        'jobSlots': json['jobSlots'],
        'durationInMonths': json['durationInMonths'],
        'pricePerMonthExclVat': json['pricePerMonthExclVat'],
    };
}
export function ListCompanySubscriptionsCompanySubscriptionDtoToJSON(json) {
    return ListCompanySubscriptionsCompanySubscriptionDtoToJSONTyped(json, false);
}
export function ListCompanySubscriptionsCompanySubscriptionDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'subscriptionId': value['subscriptionId'],
        'name': value['name'],
        'status': SubscriptionStatusToJSON(value['status']),
        'startDate': ((value['startDate']).toISOString()),
        'endDate': value['endDate'] === null ? null : (value['endDate']?.toISOString()),
        'jobSlots': value['jobSlots'],
        'durationInMonths': value['durationInMonths'],
        'pricePerMonthExclVat': value['pricePerMonthExclVat'],
    };
}
